import { useEffect, useState } from "react";
import { SubscriptionPlanPdf } from "../../assets/images";
import FullScreenDialog from "../commons/FullScreenDilog/FullScreenDilog";
import MobileFeatures from "./MobileFeatures";

const useWindowWidth = () => {
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return width;
};


type AppProps = {
  fetching: boolean;
  modal: boolean;
  toggleModal: () => void;
  sucess: any;
};
const ShowSubscriptionPlanModal = ({
  fetching,
  toggleModal,
  sucess,
}: AppProps) => {
  const width = useWindowWidth();
  const isMobile = width <= 768;

  const previewBody = () => {


    return (
      <>
        {isMobile ? <MobileFeatures /> : <iframe
          src={`/subscriptionPlanPdf.pdf`}
          title="Subscription Plan"
          width="100%"
          height="600px"
        />}
      </>
    );
  };

  return (
    <div>
      <FullScreenDialog
        success={sucess}
        onClose={toggleModal}
        showSchedulingEstimateData={[]}
        title={"Subscription Plan"}
        body={previewBody}
        onSubmit={() => { }}
      />
    </div>
  );
};

export default ShowSubscriptionPlanModal;
